<div id="footer">
  <div class="container-fluid mt-5 mb-5">
    <div class="row justify-content-between">
      <div class="col-lg-4 col-md-12">
        <h2>California Hispanic Chambers of Commerce</h2>
        <div class="d-flex gap-3 align-items-center my-2">
          <a
            href="https://www.facebook.com/CAHispanic"
            title="Facebook"
            target="_blank"
          >
            <fa-icon [icon]="faFacebookF" size="lg" class=""></fa-icon>
          </a>
          <a
            href="https://www.linkedin.com/in/cahispanic"
            title="LinkedIn"
            target="_blank"
          >
            <fa-icon [icon]="faLinkedinIn" size="lg" class=""></fa-icon>
          </a>
          <a
            href="https://twitter.com/cahispanic"
            title="Twitter"
            target="_blank"
          >
            <fa-icon [icon]="faTwitter" size="lg" class=""></fa-icon>
          </a>
          <a
            href="https://www.instagram.com/cahispanic"
            title="Instagram"
            target="_blank"
          >
            <fa-icon [icon]="faInstagram" size="lg" class=""></fa-icon>
          </a>
          <a
            href="https://www.youtube.com/@californiahispanicchambers5018/videos"
            title="YouTube"
            target="_blank"
          >
            <fa-icon [icon]="faYoutube" size="lg" class=""></fa-icon>
          </a>
        </div>
      </div>
      <div class="col-lg-4 col-md-12">
        <p>
          <a class="iconLinks" target="_blank" href="mailto:info@cahcc.com">
            <fa-icon [icon]="faEnvelope"></fa-icon>
            info&#64;cahcc.com
          </a>
        </p>
        <p>
          <a class="iconLinks" target="_blank" href="tel: 916.444.2221">
            <fa-icon [icon]="faPhoneAlt"></fa-icon>
            916.444.2221
          </a>
        </p>
        <p>
          <a
            class="iconLinks"
            target="_blank"
            href="https://goo.gl/maps/m3R46uDNLdWZJpp5A"
          >
            <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
            1510 J Street, Suite 210, Sacramento, CA 95814
          </a>
        </p>
      </div>
    </div>
  </div>
</div>